import { jsonLdScriptProps } from "react-schemaorg/dist/src/json-ld";
import { BoatTrip, BreadcrumbList } from "schema-dts";
import organizationSchema from "../../components/SEO/organization-json-ld-data";
import { toUTCDate } from "src/utils/date";
import { languageSpecificHomepagePath } from "src/utils/routing/pathHelpers";
import { Language } from "src/utils/localization/languages/types";
import { legacyUrl, urlWithFullDomain } from "src/utils/routing/legacyUrl";

type Args = {
  language: Language;
  image?: string;
  name?: string;
  description?: string;
  cruiseCode?: string;
  pathname: string;
  departureDate?: string;
  arrivalDate?: string;
  departureCityName?: string;
  arrivalCityName?: string;
  itinerary?: ItineraryItem[];
  destinationName?: string;
  destinationUrl?: string;
};

type ItineraryItem = {
  name: string;
};

export const buildCruiseJsonLd = ({
  language,
  image,
  name,
  pathname,
  arrivalCityName,
  arrivalDate,
  cruiseCode,
  departureCityName,
  departureDate,
  description,
  itinerary,
  destinationName,
  destinationUrl
}: Args) => [
  jsonLdScriptProps<BreadcrumbList>({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Silversea Cruises",
        item: urlWithFullDomain(
          legacyUrl(languageSpecificHomepagePath(language))
        )
      },
      {
        "@type": "ListItem",
        position: 2,
        name: destinationName,
        item: urlWithFullDomain(destinationUrl)
      },
      {
        "@type": "ListItem",
        position: 3,
        name: name
      }
    ]
  }),
  jsonLdScriptProps<BoatTrip>({
    "@context": "https://schema.org",
    "@type": "BoatTrip",
    "@id": `#cruise`,
    description: description,
    provider: organizationSchema,
    image: image,
    name: name,
    identifier: cruiseCode,
    url: urlWithFullDomain(pathname),
    departureBoatTerminal: {
      "@type": "BoatTerminal",
      name: departureCityName
    },
    arrivalBoatTerminal: {
      "@type": "BoatTerminal",
      name: arrivalCityName
    },
    departureTime: departureDate
      ? toUTCDate(departureDate).toISOString()
      : undefined,
    arrivalTime: arrivalDate ? toUTCDate(arrivalDate).toISOString() : undefined,
    itinerary: itinerary
      ? {
          "@type": "ItemList",
          numberOfItems: itinerary.length,
          itemListElement: itinerary.map((i, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: {
              "@type": "Place",
              name: i.name
            }
          }))
        }
      : undefined
  })
];
